import { IconType } from 'components/Icon';
import ActionButton from 'components/Widget/ActionButton';
import { MenuItemAction } from 'menu/MenuItem';
import { useSelector } from 'react-redux';
import { selectActiveDesignSystem } from 'redux/db/reducers';
import { RootReducer } from 'redux/reducers';

const DiscardChangesAction = () => {
	const designSystem = useSelector((r: RootReducer) =>
		selectActiveDesignSystem(r.db, r.mode.activeDesignSystemId)
	);

	const onClick = () => {
		if (!designSystem) return;
		MenuItemAction.createDiscardDsChanges(designSystem.id, designSystem.title).callback();
	};

	return <ActionButton icon={IconType.UNDO} label="Discard draft changes" onClick={onClick} />;
};

export default DiscardChangesAction;
